<template>
  <div class="container who-are-you">
    <div class="row pt-3">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="8" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-5">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/whoAreYou.png" alt="who-are-you-image">
      </div>
    </div>
    <div class="row row-birth">
      <div class="offset-1 col-10 offset-md-3 col-md-6">
        <label class="field">{{ $t('whoAreYou.birth') }}</label>
      </div>
    </div>
    <div class="row">
      <div class="offset-1 col-10 offset-lg-3 col-lg-6">
        <input @keyup.enter="$refs.weight.focus"
          onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
          type="number"
          v-model="age"
          v-bind:class='!$v.age.between ? "age-error": ""'
          class="text-lg-center age"
          ref="age">
      </div>
      <div class="offset-1 col-10 offset-lg-3 col-lg-6">
        <span class="error" v-if="!$v.age.between">
          {{ $t('whoAreYou.legalAge') }}
        </span>
      </div>
    </div>
    <div class="row pt-3 pt-lg-2">
      <div class="offset-1 col-5 offset-md-3 col-md-3">
        <div class="row">
          <div class="col-12">
            <label class="field">{{ $t('whoAreYou.weight') }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <input @keyup.enter="$refs.height.focus"
              v-model="weight"
              v-if="weightMetric === 'kg'"
              v-bind:class='!$v.weight.between ? "age-error": ""'
              onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 190 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              type="number"
              class="input-field"
              ref="weight"/>
            <input @keyup.enter="$refs.height.focus"
              v-model="lb"
              v-if="weightMetric === 'lb'"
              v-bind:class='!$v.lb.between ? "age-error": ""'
              onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 190 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              type="number"
              class="input-field"
              ref="weight"/>
          </div>
          <div class="col-4 col-percentile text-center" @click="changeMetric">
            <label class="label-percentile">
              {{ weightMetric }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-5 col-md-3">
        <div class="row">
          <div class="col-12">
            <label class="field">{{ $t('whoAreYou.height') }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <input v-model="height"
              v-if="heightMetric === 'cm'"
              v-bind:class='!$v.height.between ? "age-error": ""'
              onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 190 || event.keyCode === 222 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              type="text"
              class="input-field"
              ref="height"/>
            <input v-model="ftInches"
              v-if="heightMetric === 'ft'"
              v-bind:class='!$v.realft.between ? "age-error": ""'
              onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 190 || event.keyCode === 222 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
              type="text"
              class="input-field"
              ref="height"/>
          </div>
          <div class="col-4 col-percentile text-center" @click="changeMetric">
            <label class="label-percentile">
              {{ heightMetric }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-lg-5 row-next">
      <div class="col-12 offset-md-4 col-md-4 text-center">
        <button class="btn btn-lg text-light continue" @click="next">{{ $t('general.next') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import { required, between } from 'vuelidate/lib/validators'
const convert = require('convert-units')

export default {
  data () {
    return {
      name: '',
      weight: '',
      weightMetric: 'lb',
      height: '',
      heightMetric: 'ft',
      selectedDay: '',
      selectedMonth: '',
      selectedYear: '',
      age: '',
      ftInches: '',
      ft: '',
      inch: 0,
      lb: '',
      realft: ''
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    changeMetric () {
      switch (this.weightMetric) {
        case 'lb':
          this.weightMetric = 'kg'
          this.toKg(this.lb)
          break
        case 'kg':
          this.weightMetric = 'lb'
          this.toLb(this.height)
          break
      }

      switch (this.heightMetric) {
        case 'ft':
          this.ftInchesToCm()
          this.heightMetric = 'cm'
          break
        case 'cm':
          this.heightMetric = 'ft'
          this.toFeet(this.height)
          break
      }
    },
    convertMetric (metric, from, to) {
      switch (metric) {
        case 'weight':
          if (this.weight !== '') {
            this.weight = convert(this.weight).from(from).to(to)
          }
          break
        case 'height':
          if (this.height !== '') {
            this.height = convert(this.height).from(from).to(to)
          }
          break
      }
    },
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('whoAreYou.missingFields')
        })
      } else {
        let birthDate = new Date()
        birthDate.setFullYear(birthDate.getFullYear() - this.age)

        const register = [
          { key: 'birthDate', data: parseInt((birthDate.getTime() / 1000).toFixed(0)) },
          { key: 'height', data: this.heightMetric === 'cm' ? this.height : (Number(this.ft) + convert(this.inch).from('in').to('ft')) },
          { key: 'heightMetric', data: this.heightMetric },
          { key: 'weight', data: this.weightMetric === 'kg' ? this.weight : this.lb },
          { key: 'weightMetric', data: this.weightMetric }
        ]

        this.$store.commit('SET_REGISTER_INFORMATION', register)

        this.$router.push({
          name: 'chroniccondition'
        })
      }
    },
    toLb (kg) {
      if (kg !== '') {
        this.lb = convert(kg).from('kg').to('lb')
      }
    },
    toKg (lb) {
      if (lb !== '') {
        this.weight = convert(lb).from('lb').to('kg')
      }
    },
    toFeet (cm) {
      if (cm !== '') {
        let realFeet = ((cm * 0.393700) / 12)
        let feet = Math.floor(realFeet)
        let inches = Math.round((realFeet - feet) * 12)
        this.ft = feet
        this.inch = inches
        this.ftInches = feet + '\'' + inches
      }
    },
    toCm (feet, inch) {
      let cm = ((feet * 12) + inch) * 2.54
      this.height = cm
    },
    ftInchesToCm () {
      if (this.ftInches !== '') {
        if (this.ftInches.includes('\'')) {
          let feet = 0
          let inch = 0
          let res = this.ftInches.split('\'')
          if (res.length === 2) {
            if (res[1] !== '') {
              inch = Number(res[1])
            }
          }

          feet = res[0]
          this.toCm(feet, inch)
          this.ft = Number(res[0])
          this.realft = Number(feet) + convert(inch).from('in').to('ft')
        } else {
          this.ft = this.ftInches
          this.realft = Number(this.ftInches)
          this.toCm(this.ftInches, 0)
        }
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'whoareyou')
  },
  validations: {
    weight: {
      required,
      between: between(20, 300)
    },
    lb: {
      required,
      between: between(44.09248840367555, 661.3873260551333)
    },
    height: {
      required,
      between: between(50, 300)
    },
    ft: {
      required,
      between: between(1, 9)
    },
    realft: {
      required,
      between: between(1.6666666666666665, 9.833333333333334)
    },
    age: {
      required,
      between: between(18, 120)
    }
  },
  watch: {
    ftInches (value) {
      if (value !== '') {
        if (this.heightMetric === 'ft') {
          if (value.includes('\'')) {
            let feet = 0
            let inch = 0
            let res = value.split('\'')
            if (res.length === 2) {
              if (res[1] !== '') {
                inch = Number(res[1])
              }
            }

            feet = res[0]
            this.toCm(feet, inch)
            this.ft = Number(res[0])
            this.realft = Number(feet) + convert(inch).from('in').to('ft')
          } else {
            this.ft = value
            this.realft = Number(value)
            this.toCm(value, 0)
          }
        } else {
          if (value.includes('\'')) {
            let feet = 0
            let inch = 0
            let res = value.split('\'')
            if (res.length === 2) {
              if (res[1] !== '') {
                inch = Number(res[1])
              }
            }

            feet = res[0]
            this.realft = Number(feet) + convert(inch).from('in').to('ft')
          } else {
            this.realft = Number(value)
          }
        }
      }
    },
    height (value) {
      if (this.heightMetric === 'cm' && value !== '') {
        this.toFeet(value)
      }
    },
    weight (value) {
      if (this.weightMetric === 'kg' && value !== '') {
        this.toLb(value)
      }
    },
    lb (value) {
      if (this.weightMetric === 'lb' && value !== '') {
        this.toKg(value)
      }
    }
  }
}
</script>

<style>
.who-are-you .row-birth {
  padding-top: 5rem;
}

.who-are-you .field {
  font-weight: 400;
  font-size: 1rem;
}

.who-are-you .age {
  color: #2bb1c4;
  text-align: center;
  height: 50px;
  border: 1px solid #c2c7c7;
  font-weight: 800;
  font-size: 1.1rem;
  width: 100%;
  border-radius: 5px;
}

.who-are-you .age-error {
  border-color: red !important;
}

.who-are-you .error {
  color: red;
}

.who-are-you .input-field {
  width: 100%;
  height: 50px;
  border: 1px solid #c2c7c7;
  border-radius: 5px;
  color: #2bb1c4;
  font-weight: 800;
  font-size: 1.1rem;
  text-align: center;
}

.who-are-you .date-field {
  text-align: center;
}

.who-are-you .col-percentile {
  padding-left: 4px;
  padding-right: 4px;
}

.who-are-you .label-percentile {
  width: 100%;
  height: 100%;
  padding-top: 1rem;
  background-color: #162c2f;
  color: white;
  border-radius: 5px;
  font-weight: 400;
  font-size: 1.15rem;
}

.who-are-you .row-next {
  padding-top: 8rem;
}

.who-are-you .continue {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: bold;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .who-are-you .img-question {
    height: 20vh;
  }

  .who-are-you .row-birth {
    padding-top: 2rem;
  }

  .who-are-you .row-next {
    padding-top: 3rem;
  }

  .who-are-you .continue {
    min-height: 70px;
    font-weight: bold;
  }
}
</style>
